
import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../components/ui/card";
import Hero from "../components/therapists/Hero";
import Features from "../components/therapists/Features";
import Testimonials from "../components/therapists/Testimonials";
import Pricing from "../components/therapists/Pricing";
import PricingOptions from "../components/therapists/PricingOptions";
import FAQ from "../components/therapists/Faq";
import CTA from "../components/therapists/Cta";

const ForTherapists = () => {

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Hero />
        <div className="container">
          <hr className="text-primary"></hr>
        </div>
        <Features />
        <div className="container">
          <hr className="text-primary"></hr>
        </div>
        <PricingOptions />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default ForTherapists;
